module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAHlBMVEXvM0AAAAD92iXKysr/4iXxTDv6vyn72CXUtx8lIQXIozIZAAAAnElEQVR42u3dMQ0AIRAAwUtewZe0OCB4oEYLGhCOAZrrKGYVjION/mTR/mRlr5przEj2YWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYV1Zj65gDsiGz+LOKzrVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/25.png
// module id = QEmU
// module chunks = 1